import BidList from "components/bids/list";
import DocumentTrackingBid from "./item";

export default class DocumentTrackingBidList extends BidList {
    factoringEnabled = false;

    get tableColumnMapper() {
        return {
            ...super.tableColumnMapper,
            lastParcelFixedAt: "status",
        };
    }

    get dropdActions() {
        return {
            ...super.dropdActions,
            status: [
                {
                    text: "По дате статуса (по возр.)",
                    action: this.props.sortData.bind(this, [{ name: "lastParcelFixedAt", value: "asc" }]),
                },
                {
                    text: "По дате статуса (по убыв.)",
                    action: this.props.sortData.bind(this, [{ name: "lastParcelFixedAt", value: "desc" }]),
                },
            ],
        };
    }

    get RowComponent() {
        return DocumentTrackingBid;
    }
}
